<template>
  <div>
    <div>
      <a-dropdown :trigger="['hover']" placement="bottomCenter">
        <div>
          
          <a-space size="small"
            >
            <img :src="'getImg/'+currentUser.photo" class="head-img" v-if="currentUser.photo" />
            <a-icon type="user" v-else/>
            
            {{ currentUser.nickName }}</a-space
          >
        </div>
        <a-menu slot="overlay" class="menu-list">
          <a-menu-item>
            <div @click="openUser()">修改个人资料</div>
          </a-menu-item>
          <a-menu-item>
            <div @click="updatePassword()">修改密码</div>
          </a-menu-item>
          <a-menu-item>
            <div @click="logout()">安全退出</div>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
    <div>
      <a-modal
        v-model="userVisible"
        title="修改个人资料"
        cancelText="取消"
        okText="确认"
        @ok="updateDetail"
      >
        <a-form :form="formDetail" @submit="handleSubmit">
          <a-form-item v-bind="formItemLayout">
            <span slot="label">
              昵称&nbsp;
              <a-tooltip title="用于展示给其他用户">
                <a-icon type="question-circle-o" />
              </a-tooltip>
            </span>
            <a-input
              v-decorator="[
                'nickName',
                {
                  initialValue: currentUser.nickName,
                  rules: [
                    {
                      required: true,
                      message: '请输入您的昵称',
                      whitespace: true,
                    },
                    {
                      validator: validateNickName,
                    },
                  ],
                },
              ]"
            />
          </a-form-item>

          <a-form-item v-bind="formItemLayout">
            <span slot="label"> 电话&nbsp; </span>
            <a-input
              v-decorator="[
                'tel',
                {
                  initialValue: currentUser.tel,
                  rules: [{ message: '请输入您的电话', whitespace: true }],
                },
              ]"
            />
          </a-form-item>
           <a-form-item v-bind="formItemLayout">
            <span slot="label"> 头像&nbsp; </span>
             <Avatar :getImgUrl="getImgUrl" :url="currentUser.photo"/>
          </a-form-item>
        </a-form>
      </a-modal>
    </div>

    <div>
      <a-modal
        v-model="pwVisible"
        title="修改密码"
        cancelText="取消"
        okText="确认修改"
        @ok="handleSubmit"
      >
        <a-form :form="form" @submit="handleSubmit">
          <a-form-item v-bind="formItemLayout" label="旧密码" has-feedback>
            <a-input
              v-decorator="[
                'oldPassword',
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入您的旧密码!',
                    },
                  ],
                },
              ]"
              type="password"
            />
          </a-form-item>
          <a-form-item v-bind="formItemLayout" label="新密码" has-feedback>
            <a-input
              v-decorator="[
                'newPassword',
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入您的密码!',
                    },
                    {
                      validator: validateToNextPassword,
                    },
                  ],
                },
              ]"
              type="password"
            />
          </a-form-item>
          <a-form-item v-bind="formItemLayout" label="确认密码" has-feedback>
            <a-input
              v-decorator="[
                'confirm',
                {
                  rules: [
                    {
                      required: true,
                      message: '确认密码!',
                    },
                    {
                      validator: compareToFirstPassword,
                    },
                  ],
                },
              ]"
              type="password"
              @blur="handleConfirmBlur"
            />
          </a-form-item>
        </a-form>
      </a-modal>
    </div>
  </div>
</template>

<script>
import Avatar from "./Avatar";
export default {
  data() {
    return {
      userVisible: false,
      pwVisible: false,
      confirmDirty: false,
      autoCompleteResult: [],
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 4 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 18 },
        },
      },
      tailFormItemLayout: {
        wrapperCol: {
          xs: {
            span: 24,
            offset: 0,
          },
          sm: {
            span: 16,
            offset: 8,
          },
        },
      },
    };
  },
  components: { Avatar },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "form" });
    this.formDetail = this.$form.createForm(this, { name: "formDetail" });
  },
  methods: {
    update() {
      this.$req.post("/api/user/update-info", this.currentUser, (res) => {
        this.$message.success("信息修改成功");
        this.userVisible = false;
      });
    },
    getImgUrl(imgUrl){
      this.currentUser.photo=imgUrl;
    },
    openUser() {
      this.userVisible = true;
    },
    updatePassword() {
      this.pwVisible = true;
    },
    logout() {
      this.$req.get("/api/user/login/out", {}, (res) => {
        this.$message.success("登出成功！");
        this.userVisible = false;
        this.$router.push("/login");
      });
    },
    compareToFirstPassword(rule, value, callback) {
      const form = this.form;
      if (value && value !== form.getFieldValue("newPassword")) {
        callback("两次密码不一致，请重新输入!");
      } else {
        callback();
      }
    },
    validateToNextPassword(rule, value, callback) {
      const form = this.form;
      if (value && this.confirmDirty) {
        form.validateFields(["confirm"], { force: true });
      }
      callback();
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.$req.formDataPost("/api/user/update/password" , {
            oldPassword:values.oldPassword,
            newPassword:values.newPassword
          }, (res) => {
            this.$message.success("密码修改成功");
            this.pwVisible = false;
            this.form.resetFields();
          });
        }
      });
    },
    handleConfirmBlur(e) {
      const value = e.target.value;
      this.confirmDirty = this.confirmDirty || !!value;
    },
    validateNickName(rule, value, callback) {
      if (!value) {
        callback();
        return;
      }
      const form = this.formDetail;
      this.$req.formDataPost(
        "/api/user/check/nick-name",
        { nickName: value },
        (res) => {
          if (res.data) {
            callback();
          } else {
            callback("昵称已存在，请重新更换一个试试");
          }
        }
      );
    },
    updateDetail(e) {
      e.preventDefault();
      this.formDetail.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.currentUser.nickName = values.nickName;
          this.currentUser.tel = values.tel;
          this.$req.post("/api/user/update/info", this.currentUser, (res) => {
            this.$message.success("信息修改成功");
            this.userVisible = false;
          });
        }
      });
    },
  },

  computed: {
    currentUser: function () {
      return this.$store.state.user;
    },
  },
};
</script>

<style scoped>
.head-img{
    width: 40px;
    height: 40px;
}
</style>